import {
  Box,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { WhyPodCard } from './WhyPodCard';
import whyPodIcon from 'assets/images/whyPodIcon.svg';
import safeguard from 'assets/images/safeguard.svg';
import transparent from 'assets/images/transparent.svg';
import qualityStartups from 'assets/images/qualityStartups.svg';
import investorFriendly from 'assets/images/investorFriendly.svg';

export const WhyPod = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      component="section"
      bgcolor="#F8FBF5"
      mt="29px"
      sx={{
        pt: {
          xs: 0,
          md: 8,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ bgcolor: '#E6F0F1' }}>
        <Box display="flex" alignItems="center">
          <img src={whyPodIcon.src} alt="why pod icon" />
          <Box flexGrow={1}>
            <Typography
              fontWeight={600}
              fontSize={24}
              color="#FF6446"
              letterSpacing="0.01em"
              mb="10px"
              mt="40px"
              sx={{
                fontSize: {
                  xs: 18,
                  md: 24,
                },
              }}
            >
              For Seamless Funding Experience
            </Typography>
            <Typography
              fontWeight={900}
              fontSize={40}
              color="#004643"
              mb="19px"
            >
              Why POD
            </Typography>
          </Box>
        </Box>
        {/* <Grid container sx={{ bgcolor: '#F8FBF5' }}>
          <Grid item md={6}>
            <WhyPodCard
              title="Investor Friendly"
              content="asfsdfsdf"
              icon={investorFriendly.src}
            />
          </Grid>
          <Grid item md={6}>
            ssdfsasdasdsd
          </Grid>
        </Grid> */}
      </Container>
      <Container
        sx={{
          mt: 8,
          px: {
            md: '0 !important',
          },
        }}
      >
        <Grid container rowSpacing={matches ? 2 : 8} pb={8}>
          {/* <Grid item md={6}>
            <WhyPodCard
              title="Investor Friendly"
              content={
                <Typography
                  color="rgba(0, 0, 0, 0.6)"
                  sx={{
                    '& span': {
                      color: '#E65D45',
                    },
                  }}
                >
                  POD is an investor-friendly platform, which{' '}
                  <span>levies no commission</span>
                  or <span>hidden charges</span> from investors.
                </Typography>
              }
              icon={investorFriendly.src}
            />
          </Grid> */}
          <Grid item md={6}>
            <WhyPodCard
              title="Streamlined Process"
              content={
                <Typography
                  color="rgba(0, 0, 0, 0.6)"
                  sx={{
                    '& span': {
                      color: '#E65D45',
                    },
                  }}
                >
                  Hassle-free <span>end-to-end</span> process designed for
                  smooth fundraising experience.
                </Typography>
              }
              icon={transparent.src}
            />
          </Grid>
          <Grid item md={6}>
            <WhyPodCard
              title="Credible Investors"
              content={
                <Typography
                  color="rgba(0, 0, 0, 0.6)"
                  sx={{
                    '& span': {
                      color: '#E65D45',
                    },
                  }}
                >
                  POD hosts <span>2000+</span> verified retail and angel
                  investors on the platform.
                </Typography>
              }
              icon={qualityStartups.src}
            />
          </Grid>
          <Grid item md={6}>
            <WhyPodCard
              title="Easy Investor Reporting"
              content={
                <Typography
                  color="rgba(0, 0, 0, 0.6)"
                  sx={{
                    '& span': {
                      color: '#E65D45',
                    },
                  }}
                >
                  Smart tool to <span>track</span> and manage investor
                  reporting.
                </Typography>
              }
              icon={safeguard.src}
            />
          </Grid>
          <Grid item md={6}></Grid>
        </Grid>
      </Container>
    </Box>
  );
};
